import React, { useRef, useState } from "react"
import Layout from "../components/layout"
import "../styles/slider.scss"
import { graphql, useStaticQuery, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { FaSearch } from "react-icons/fa"
import * as indexStyles from "../styles/index.module.css"
import serviceFaq from "../images/home/faq.png"
import serviceFeed from "../images/home/feed.png"
import serviceTestimonial from "../images/home/testimonial.png"

import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core"
import TestimonialSwiper2 from "../components/TestimonialSwiper2"

// install Swiper modules

export default function Home() {
  // Fetching Testimonials

  const { allStrapiTestimonial } = useStaticQuery(graphql`
    {
      allStrapiTestimonial {
        edges {
          node {
            keywords {
              id
              label
            }
            name
            id
            displaypicture {
              childImageSharp {
                fluid {
                  aspectRatio
                  base64
                  originalImg
                  originalName
                  presentationHeight
                  src
                  presentationWidth
                  sizes
                  srcSet
                  srcSetWebp
                  srcWebp
                  tracedSVG
                }
              }
            }
          }
        }
      }
    }
  `)
  const testimonials = allStrapiTestimonial.edges.map(edge => edge.node)
  

  return (
    <Layout>

      {/* Landing Content */}

      <div className={indexStyles.landing}>
        <div className={indexStyles.landingContent}>
          <div>
            <h3>Life is all about the route you take</h3>
          </div>
        </div>
      </div>

      {/* Services Content */}

      <div className={indexStyles.services}>
        <h3>What We Have In Store For You</h3>
        <div className={indexStyles.servicesOptions}>
          <div className={indexStyles.serviceCard}>
            <img src={serviceTestimonial} />
            <h4>Testimonials</h4>
            <p>
              First hand experiences of seniors and alumni curated just for you!
            </p>
          </div>
          <div className={indexStyles.serviceCard}>
            <img src={serviceFaq} />
            <h4>QnA</h4>
            <p>
              Confused on how to explore a field? Don’t know what lies ahead of
              you? Take a dive into these field specific QnAs
            </p>
          </div>
        </div>
      </div>

      {/* Fields Grid */}

      <div className={indexStyles.fields}>
        <h3>Which Field Are You Interested In</h3>
        <div className={indexStyles.fieldsContainer}>
          <div className={indexStyles.fieldsColumn}>
            <Link className={indexStyles.fieldsLink} to={`/Finance`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box11}>
                <h2 className={indexStyles.fieldsName}>Finance</h2>
              </div>
            </Link>
            <Link className={indexStyles.fieldsLink} to={`/Consultancy`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box12}>
                <h2 className={indexStyles.fieldsName}>Consultancy</h2>
              </div>
            </Link>
            <Link className={indexStyles.fieldsLink} to={`/Entrepreneurship`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box13}>
                <h2 className={indexStyles.fieldsName}>Entrepreneurship</h2>
              </div>
            </Link>
          </div>
          <div className={indexStyles.fieldsColumn}>
            <Link className={indexStyles.fieldsLink} to={`/IT`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box21}>
                <h2 className={indexStyles.fieldsName}>IT</h2>
              </div>
            </Link>
            <Link
              className={indexStyles.fieldsLink}
              to={`/Supply Chain Management`}
            >
              <div className={indexStyles.fieldsBox} id={indexStyles.box22}>
                <h2 className={indexStyles.fieldsName}>
                  Supply Chain Management
                </h2>
              </div>
            </Link>
            <Link className={indexStyles.fieldsLink} to={`/Product Management`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box23}>
                <h2 className={indexStyles.fieldsName}>Product management</h2>
              </div>
            </Link>
          </div>
          <div className={indexStyles.fieldsColumn}>
            <Link className={indexStyles.fieldsLink} to={`/Research`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box31}>
                <h2 className={indexStyles.fieldsName}>Research</h2>
              </div>
            </Link>
            <Link className={indexStyles.fieldsLink} to={`/Core`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box32}>
                <h2 className={indexStyles.fieldsName}>Core</h2>
              </div>
            </Link>
            <Link className={indexStyles.fieldsLink} to={`/Miscellaneous`}>
              <div className={indexStyles.fieldsBox} id={indexStyles.box33}>
                <h2 className={indexStyles.fieldsName}>Miscellaneous</h2>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Gen FAQS using Material UI Accordion Component */}

      <div className={indexStyles.faqContainer}>
        <div className={indexStyles.faqWrapper}>
          <h3>QnA</h3>
          <div className={indexStyles.accordionsContainer}>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  Each field of pure science has so many subfields. How can one
                  figure out what he or she likes the most?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/6">
                    <b>Devashi Gulati</b>
                  </Link>
                  : If you have a free day with no social obligations and if you
                  feel like opening a book of a particular subject to simply
                  learn more, you might have a passion for that subject. If the
                  teacher teaches X amount, and if you feel like doing X+1 (like
                  just reading more about it, doing some extra questions from
                  the book), you do have an innate curiosity for that subject.
                  There might be subjects that you do not find fascinating
                  enough to go that extra mile. You’ll just understand the
                  syllabus, and while you will spend time thinking about those
                  concepts, you might not feel like making the effort to do
                  more. That means that subject doesn’t intrigue you enough. And
                  you should never be troubled by the fact that there is more
                  than one field that excites you. When you’re applying for a
                  PhD, it isn’t simply the field that contributes, the advisor,
                  the funding play an important role. We don’t live in an ideal
                  world. You might prefer to go for the subject where the
                  advisor is better and where the program is self-funded, even
                  if that subject wasn’t on the top of your list of favorites.
                  The bottom line is, choosing a subfield of interest is a
                  decision that depends on multiple factors.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  What are the traits of an entrepreneur?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/16">
                    <b>Joyneel Acharya</b>
                  </Link>
                  : One trait is risk taking , gut based intuition and a super
                  structured mindset in terms of what you are learning, who you
                  are speaking to etc. You have to be someone who takes control
                  and makes things structured. Unless you are the CTO, you have
                  to be a people's person, you have to motivate them and give
                  them direction. It always helps if you have a little bit of
                  technical knowledge. Even if you are a 16 yr old who is
                  starting something, you have to build a network of people.
                  Perseverance and patience are other qualities. You have to be
                  smart, it's not like that in a traditional business as you can
                  look at the other businesses around you, with a startup you
                  require quick thinking and quick decision making. You have to
                  be quick and think long term. It's a mix of both the left
                  brain and the right brain.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  What’s your take on MBA?
                </h3>
              </AccordionSummary>
              <AccordionDetails style={{ flexFlow: "column" }}>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/2">
                    <b>Anindita Dutta</b>
                  </Link>
                  : One should not pursue MBA right after undergraduate. MBA
                  courses aren’t something you’re gonna sit and learn. Most of
                  them revolve around experiences-sharing your experience and
                  learning from others’. And that’s how you’re gonna bond. If
                  you come right after undergrad, you’d have nothing to anchor
                  on. Yeah, at times, studying after a long time hits you
                  slightly hard. But you need to realise that doing an MBA from
                  an IIM or any other college isn’t the end of it. You need to
                  keep reinventing yourself. It’s okay to go to school again.
                  There’s always going to be some inertia, but learning is a
                  part of the journey.
                </p>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/16">
                    <b>Joyneel Acharya</b>
                  </Link>
                  : I feel that MBAs are reducing in value as we are
                  progressing. The MBA boom was closer to 2000-2010, Those
                  things are changing a bit. You can be at par with MBA people
                  without doing MBA. MBA polishes you a bit and gives you a
                  platform but it can be self learnt. If you are a bit
                  entrepreneurial, you can carve out your own path. Oh, but
                  international MBA is different as they ask for 4-5 yrs of work
                  experience. In conclusion, MBA doesn’t hold as much charm now
                  as it used to hold 10-20 years ago.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  What is the ideal time to start competitive coding?
                </h3>
              </AccordionSummary>
              <AccordionDetails style={{ border: "none" }}>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/8">
                    <b>Varun Gupta</b>
                  </Link>
                  : In the first year, I would encourage people to focus more on
                  the CGPA, because that is a time when you can actually improve
                  it a lot, it becomes difficult to improve it later on. Enjoy
                  college life and build connections. But at the end of the
                  first year, you should be able to write good and acceptable
                  code in a particular language. The next thing is to learn data
                  structures. At the start of 2-1, you should probably start
                  exploring what data structures are and what their applications
                  are, the time complexity calculations etc. So in 2-1, unless
                  you're very keen on doing competitive coding, you can just do
                  proper research into what all data structures, algorithms are
                  there and just try and improve yourself on those. By 2-2,
                  start exploring websites doing Competitive Coding questions on
                  multiple topics including dynamic programming, graphs, and all
                  of those complex data structures.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  What kind of tasks are given to IT interns?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  <Link to="/testimonial/8">
                    <b>Varun Gupta</b>
                  </Link>
                  : 1) Building a specific functionality, or Integrate some
                  particular logic- The Mentor would transfer knowledge to the
                  intern about the task and the intern would just be expected to
                  write code for that particular thing. In case of an abstract
                  task, the intern would have to figure out different ways to
                  approach the problem statement and conclude on the best one.
                  They would generally need to align the team on why some
                  approach is better than the others. 2) Infrastructure based:
                  Setting up some well-defined infrastructure for the service or
                  the application.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
      <div className={indexStyles.testimonialContainer}>
        <div className={indexStyles.testimonialsContainer}>
          <TestimonialSwiper2 data={testimonials} />
        </div>
      </div>
      <div className={indexStyles.faqContainer}>
        <div
          className={indexStyles.faqWrapper}
          style={{ backgroundColor: "#ECE1D4" }}
        >
          <h3>Confused About Where To Begin?</h3>
          <div className={indexStyles.accordionsContainer}>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  I’d like to go through seniors’ opinions on a particular
                  aspect. It’s a pretty generic topic, so I’d like the views of
                  many seniors in a single place. Is there anywhere I can find
                  that?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  Absolutely! Check out the webpage of the field you’re
                  interested in. We’ve collected some frequently asked questions
                  (pertaining to that field) and have compiled advice from all
                  seniors at a single place! Just click on the senior’s name to
                  read what he/she has to say on that topic.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  My story is a little different. I’m looking to pivot to a
                  field that’s different from my branch. I want to know if
                  there’s a senior who’s done the same.
                </h3>
              </AccordionSummary>
              <AccordionDetails style={{ border: "none" }}>
                <p className={indexStyles.accordionDetails}>
                  We’ve got you covered! Head over to the{" "}
                  <Link to="/testimonials">Testimonials</Link> page where you
                  can apply filters like branch pursued in college, CGPA,
                  companies etc., on our entire collection of testimonials. And
                  see if we have found the senior who’s just the right match for
                  you! If we haven’t, feel free to send in what exactly you’re
                  looking for at{" "}
                  <a href="mailto:contact.twigg@gmail.com">
                    contact.twigg@gmail.com
                  </a>
                  .
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  I think I’ve found a senior who’s done exactly what I aspire
                  to do. How can I learn more about his/her journey?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  We’ve made a dedicated webpage for each senior wherein we’ve
                  described their journey in detail, i.e., what decisions
                  they’ve made and what all factored into making those
                  decisions. In case after reading their webpage, you still have
                  some unanswered queries, feel free to get in touch with them
                  on the contact platforms mentioned beneath their name. We’ve
                  specially requested each senior to share their contact details
                  where they’re relatively active and would be happy to assist
                  juniors. So don’t hesitate to reach out!
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  I have a question that hasn’t been answered on this website
                  yet. Is there any way I can communicate this to you?
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  Yes! Email your question at{" "}
                  <a href="mailto:contact.twigg@gmail.com">
                    contact.twigg@gmail.com
                  </a>
                  , and we’ll try to get it answered by the seniors we call
                  next.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ borderBottom: "0.5px solid black" }}
              >
                <h3 className={indexStyles.accordionSummary}>
                  I’d like to recommend a senior whose journey can be added to
                  this website.
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <p className={indexStyles.accordionDetails}>
                  Awesome, we love contributions! Scroll down to Share A
                  Journey, add in his/her contact information. And we will sort
                  the rest!
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      {/* Contact Us Forms handled using Formspree */}

      <div id="contactus" className={indexStyles.contactusContainer}>
        <div className={indexStyles.contactusShareContainer}>
          <h3>Share your Journey</h3>
          <p>
            Do you also have a career story to tell? Or, if not, do you know
            someone who should be featured on this website? Fill in their
            details, and we will reach out to them!
          </p>
          <form action="https://formspree.io/f/xqkwqobl" method="POST">
            <div className={indexStyles.contactusFormgroup}>
              <input placeholder="Name" name="name" />
              <input placeholder="Email" name="email" />
              <div style={{ display: "flex" }}>
                <input
                  style={{ marginRight: "5px" }}
                  name="branch"
                  placeholder="Branch"
                />
                <input placeholder="Graduation Year" name="gradyear" />
              </div>
              <input
                placeholder="Add Link to Linkedin Profile/Portfolio"
                name="url"
              />
            </div>

            <button className={indexStyles.contactusButton} type="submit">
              Submit
            </button>
          </form>
        </div>
        <div className={indexStyles.contactusFeedbackContainer}>
          <h3>Help Us Improve</h3>
          <form action="https://formspree.io/f/xeqvgwkv" method="POST">
            <textarea placeholder="Type your message here" name="feedback" />
            <button className={indexStyles.contactusButton} type="submit">
              Submit
            </button>
          </form>
        </div>
      </div>
    </Layout>
  )
}
